import React, { Suspense, useMemo } from "react";
import { Canvas, useThree, useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";
import Image from "../../assets/img.jpg";
import tutorialFP from "../../assets/tutorialFP.png";
import { useDispatch, useSelector } from "react-redux";
import { setTutorialImageDimension } from "../../Actions/PopupAction";

const BackgroundImage = () => {
  const dispatch = useDispatch();
  const image=useSelector((state)=>state.ApplicationState.img);
  const tutorialActive = useSelector((state)=>state.ApplicationState.tutorialActive);
  const imageOpacity = useSelector((state)=>state.ApplicationState.imageOpacity);
  const texture = useLoader(TextureLoader, tutorialActive? tutorialFP : image? `https://${image}`: Image);
  const screenWidth = window.innerWidth * 1;
  const screenHeight = window.innerHeight * 1;
  const aspectRatio = texture.image.width / texture.image.height;
  const [fixedWidth, fixedHeight] = useMemo(()=>{
    // if(texture.image.height > screenHeight){
    //   return [screenHeight * aspectRatio, screenHeight]
    // }
    // else if(texture.image.width > screenWidth){
    //   return [screenWidth, screenWidth / aspectRatio]
    // }else{
      dispatch(setTutorialImageDimension({
        tutorialImageFixedWidth: texture.image.width,
        tutorialImageFixedHeight: texture.image.height,
      }))
      return [texture.image.width, texture.image.height]
    // }
  },[screenHeight,screenWidth,aspectRatio, tutorialActive, image])
  
  const memoImage = useMemo(()=>{
    return(
      <mesh position={[0, 0, -10]}>
      <planeGeometry args={[fixedWidth, fixedHeight]}  />
      <meshBasicMaterial map={texture}  transparent = {imageOpacity === 1 ? false: true} opacity={imageOpacity}/>
    </mesh>
    )
  },[image, imageOpacity, tutorialActive])

  return (
    image || tutorialActive? 
    <>
      {memoImage}
    </>
    : 
    null
  );
};



export default BackgroundImage;
